module.exports = __webpack_public_path__ + "static/media/tommy-logo.516204f3.gif";